import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { AccountsTableSkeleton } from "@/app/oauth/accounts/skeletons/accounts-table-skeleton";
import { AccountsTable } from "@/app/oauth/accounts/table";
import { connectedAccountsQueryOptions } from "@/app/oauth/api/get-connected-accounts";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/connected-users"
)({
  component: () => (
    <Suspense fallback={<AccountsTableSkeleton />}>
      <AccountsTable />
    </Suspense>
  ),
  beforeLoad: async (ctx) => {
    await requireProjectPermission(ctx, PROJECT.userConnections.read);
    ctx.context.queryClient.prefetchQuery(
      connectedAccountsQueryOptions({
        scope: ctx.params,
      })
    );
  },
  loader: () => ({
    crumb: "Connected Users",
  }),
});
